import Cookies from 'js-cookie';
import { CookieSetter } from './index';
export interface UserLoginType {
  auth: number;
  checkIn: string;
  id: number;
  loginId: string;
  mature: number;
  method: string;
  registerGoods: any;
  reserveGoods: any;
  sign: number;
  token: string;
  type: string;
  userId: number;
}

enum Keys {
  User = 'user',
  UserEX = 'userEX',
}
export class UserLoginService {
  static userInfo = new CookieSetter(Keys.User); // 기본 사용법 예제

  static CustomUserInfo = new CookieSetter(Keys.UserEX, {
    // 커스텀 사용법 예제
    get: (key: string): UserLoginType => {
      console.log(`${key}_customGet`);
      const obj: UserLoginType = JSON.parse(Cookies.get(key) || '{}');
      return obj;
    },
    set: (key: string, value: UserLoginType) => {
      console.log(`${key}_customSet`);
      return Cookies.set(key, JSON.stringify(value));
    },
    remove: (key: string) => {
      console.log(`${key}_customRemove`);
      return Cookies.remove(key);
    },
  });
}
